import type { TranslationsFilters } from '../models/translation';

export const translationsQueryKey = {
  all: ['translations'] as const,
  languages: () => [...translationsQueryKey.all, 'languages'] as const,
  list: (filters: Partial<TranslationsFilters>) =>
    [...translationsQueryKey.all, 'list', filters] as const,
};
